import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { isAuthenticatedUser } from 'js/lib/user';

import GetSkillPathwayCurriculumProductsQuery from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/GetSkillPathwayCurriculumProductsQuery.graphql';
import type {
  GetSkillPathwayCurriculumProductsQuery as QueryResult,
  GetSkillPathwayCurriculumProductsQueryVariables as QueryVariables,
} from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/__generated__/GetSkillPathwayCurriculumProductsQuery';

const useGetSkillPathwayCurriculumProductsQuery = ({ curriculumQueryIds }: { curriculumQueryIds?: string[] }) => {
  const {
    data: skillPathCurriculumProductsData,
    loading,
    error,
  } = useQuery<QueryResult, QueryVariables>(GetSkillPathwayCurriculumProductsQuery, {
    variables: {
      ids: curriculumQueryIds || [],
    },
    skip: !curriculumQueryIds?.length || !isAuthenticatedUser(),
  });

  if (error) {
    Sentry.captureException(error);
  }

  const skillPathCurriculumProducts =
    skillPathCurriculumProductsData?.NaptimeQueries?.ProgramCurriculumProductsV1Resource?.multiGet?.elements || [];

  return {
    skillPathCurriculumProducts,
    loading,
  };
};

export default useGetSkillPathwayCurriculumProductsQuery;
